"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SecurePathBuilder = void 0;
const utils_1 = require("../utils");
/**
 * A path builder which returns `Firestore` mapper paths which resolve
 * to interfaces with secure payloads. Takes a secure firestore mapper
 * template string and an object containing the path parameters.
 */
const SecurePathBuilder = () => {
    return (path, ...[params]) => (0, utils_1.enumKeys)(params).reduce((path, key) => {
        return path.replace(`{${key}}`, `${params === null || params === void 0 ? void 0 : params[key]}`);
    }, path);
};
exports.SecurePathBuilder = SecurePathBuilder;
//# sourceMappingURL=secure.js.map